import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { postApi } from "../../../Services/apiService";
import { ToastContainer, toast } from "react-toastify";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailActive, setEmailActive] = useState(false);
  const [errors, setErrors] = useState({ email: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    
    setIsSubmitting(true);
    try {
      const response = await postApi("/forgot-password", { email });
      if (response?.success) { 
        toast.success(response.msg || "Password reset email sent successfully");
        navigate('/login');
      } else {
        toast.error(response?.message || "Failed to send reset email");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      toast.error(error.message || "An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateForm = () => {
    const validationErrors = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    if (!email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      validationErrors.email = "Please enter a valid email address";
    }
    
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  return (
    <div className="sign-up-main login">
      {/* <ToastContainer position="top-right" autoClose={5000} /> */}
      <div className="sign-right">
        <div className="logo" onClick={() => navigate("/")}>
          <h5>We Make IT <span className="line"></span></h5>
          <h2 className="mb-0">
            Happen<span>.</span>
          </h2>
          <h2 className="mb-0 green-text">Better<span>.</span></h2>
        </div>
      </div>
      <div className="sign-left">
        <div className="start-rifgr-sec">
          <div className="text-center mb-4">
            <img 
              src={window.getPublicUrl("/assets/images/logo.svg")} 
              alt="Company Logo"
            />
          </div>
          <div className="login-container">
            <h2>Forgot your password</h2>
            <form onSubmit={handleSubmit}>
              <div className={`form-group ${emailActive ? "active" : ""}`}>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  className="form-control"
                  type="email"
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === " " && e.preventDefault()}
                  onFocus={() => setEmailActive(true)}
                  onBlur={() => setEmailActive(email.trim().length > 0)}
                />
                {errors.email && (
                  <div className="error text-danger mt-1">{errors.email}</div>
                )}
              </div>

              <div className="custom-container d-block">
                <Link to="/login" className="forget-password float-end">
                  Back to Login
                </Link>
              </div>

              <Button 
                type="submit" 
                variant="sign-in" 
                disabled={isSubmitting}
                className="w-100 mt-3"
              >
                {isSubmitting ? (
                  <>
                    <span 
                      className="spinner-border spinner-border-sm me-2" 
                      role="status" 
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  "Send Reset Email"
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;